export const selectCompany = (company) => ({
	id: parseInt(company.id, 10),
	name: company.name,
	slug: company.slug,
	privacy: company.privacyPolicyLink,
	url: company.siteUrl,
});
